<template>
	<svg
		:width="size"
		:height="size"
		viewBox="0 0 20 20"
		xmlns="http://www.w3.org/2000/svg"
		fill="none"
		role="img"
		:aria-hidden="ariaHidden"
	>
		<path
			d="M17.2383 14.7994C16.8732 14.7983 16.5121 14.7237 16.1765 14.5799C15.8409 14.4362 15.5377 14.2263 15.285 13.9627C14.7642 13.42 14.4742 12.6965 14.4758 11.9444L14.4883 8.05436C14.4888 7.82101 14.3985 7.59663 14.2367 7.42853C14.1581 7.34685 14.0639 7.28182 13.9597 7.2373C13.8555 7.19277 13.7433 7.16967 13.63 7.16936C13.4033 7.16936 13.185 7.2627 13.0242 7.42853C12.8642 7.5952 12.7733 7.8202 12.7742 8.0552L12.7617 11.946C12.7617 12.7027 12.4708 13.4294 11.9525 13.9644C11.6997 14.2277 11.3965 14.4373 11.0609 14.5808C10.7253 14.7242 10.3642 14.7986 9.99917 14.7994C9.63419 14.7984 9.27316 14.7237 8.93767 14.58C8.60219 14.4362 8.29915 14.2263 8.04667 13.9627C7.52583 13.4201 7.23602 12.6965 7.23834 11.9444L7.25001 8.05436C7.25001 7.81936 7.15917 7.59436 6.99834 7.4277C6.91996 7.34603 6.82586 7.28106 6.72171 7.23671C6.61757 7.19235 6.50553 7.16953 6.39233 7.16961C6.27913 7.16968 6.16712 7.19266 6.06303 7.23716C5.95895 7.28166 5.86494 7.34675 5.78667 7.42853C5.62584 7.5952 5.53584 7.8202 5.53584 8.0552L5.52417 11.946C5.52431 12.5083 5.36228 13.0586 5.05751 13.531C4.7581 13.9965 4.32665 14.3621 3.81834 14.581C3.31574 14.7968 2.75913 14.8535 2.22334 14.7435C1.68427 14.6317 1.19161 14.3595 0.810006 13.9627C0.551178 13.6963 0.347055 13.3818 0.209172 13.0369C0.0702701 12.6894 -0.000733614 12.3186 5.71474e-06 11.9444V8.8552C5.71474e-06 8.59436 0.100839 8.34436 0.279172 8.15936C0.457506 7.9752 0.700006 7.87103 0.952506 7.87103C1.20501 7.87103 1.44751 7.9752 1.62584 8.15936C1.80561 8.34633 1.90571 8.59582 1.90501 8.8552V11.9444C1.90501 12.1794 1.99501 12.4044 2.15584 12.5702C2.31667 12.7369 2.53501 12.8302 2.76251 12.8302C2.98917 12.8302 3.20751 12.7369 3.36834 12.5702C3.52917 12.4044 3.61917 12.1794 3.61917 11.9444L3.63167 8.05353C3.63167 7.29686 3.92251 6.57103 4.44084 6.0352C4.69361 5.7719 4.99686 5.56225 5.33248 5.41879C5.66809 5.27532 6.02918 5.20098 6.39417 5.2002C7.12667 5.2002 7.82917 5.50103 8.34667 6.03686C8.86417 6.5727 9.15501 7.29853 9.15501 8.05603L9.14334 11.9452C9.14334 12.1802 9.23417 12.4052 9.39501 12.5719C9.55584 12.7377 9.77334 12.831 10.0008 12.831C10.2283 12.831 10.4458 12.7369 10.6067 12.571C10.7675 12.4044 10.8575 12.1794 10.8575 11.9444L10.8692 8.05436C10.87 7.29686 11.1608 6.57103 11.6792 6.03603C11.9319 5.77262 12.2351 5.56285 12.5707 5.41924C12.9064 5.27563 13.2675 5.20113 13.6325 5.2002C14.365 5.2002 15.0667 5.50186 15.585 6.03686C16.1025 6.5727 16.3933 7.29853 16.3933 8.05603L16.3817 11.946C16.3817 12.181 16.4717 12.406 16.6325 12.5719C16.7942 12.7377 17.0117 12.831 17.2392 12.831C17.4667 12.831 17.6842 12.7377 17.845 12.571C18.0058 12.4044 18.0958 12.1794 18.0958 11.9444V8.85603C18.0958 8.5952 18.1958 8.3452 18.3742 8.1602C18.5533 7.97603 18.795 7.87186 19.0483 7.87186C19.3008 7.87186 19.5425 7.9752 19.7217 8.1602C19.9 8.3452 20 8.5952 20 8.85603V11.9444C20 12.701 19.7092 13.4277 19.1917 13.9627C18.939 14.2263 18.6358 14.4362 18.3002 14.5799C17.9646 14.7237 17.6034 14.7983 17.2383 14.7994Z"
			:fill="computedFill"
		/>
	</svg>
</template>

<script>
export default {
	name: 'IconKununu',
	props: {
		size: {
			type: [Number, String],
			default: 20
		},
		color: {
			type: String,
			default: 'currentColor'
		},
		filled: {
			type: Boolean,
			default: true
		},
		strokeWidth: {
			type: [Number, String],
			default: 1.65
		},
		ariaHidden: {
			type: Boolean,
			default: true
		}
	},
	computed: {
		computedFill() {
			return this.filled ? this.color : 'none'
		},
		computedStroke() {
			return this.color
		}
	}
}
</script>
